module.exports = __webpack_public_path__ + "img/txt_noDate.f878e427.png";